if (!customElements.get('tb-upsell')) {
  customElements.define('tb-upsell', class extends HTMLElement {
    connectedCallback() {
      if (this.controller || !this.dataset.url) return;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      fetch(this.dataset.url, { signal, credentials: 'same-origin' })
        .then(response => { if (!response.ok) throw new Error('Recommendations unavailable'); return response.text(); })
        .then(markup => {
          if (!this.isConnected || signal.aborted) return;
          const document = new DOMParser().parseFromString(markup, 'text/html');
          const match = Array.from(document.querySelectorAll('tb-upsell')).find(node => node.dataset.blockId === this.dataset.blockId);
          if (match?.querySelector('.tb-upsell-card')) this.innerHTML = match.innerHTML;
        })
        .catch(() => { /* Keep usable collection suggestions if recommendations are unavailable. */ });
    }
    disconnectedCallback() { this.controller?.abort(); this.controller = null; }
  });
}
